import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { useTokenStorage } from 'store';
import { RefreshResponse } from 'types/api/ApiResponseTypes';

import { getStorageKeysForNetwork } from '../utils/LocalstorageUtils';

import { getApiBaseUrl } from './utils';

interface InternalAxiosRequestConfig extends AxiosRequestConfig {
  isRetry?: boolean;
}

export const STXAxiosInstance: AxiosInstance = axios.create({
  baseURL: getApiBaseUrl(),
});

const REFRESH_ROUTE = 'auth/refresh';

const { setToken, getToken } = useTokenStorage();

STXAxiosInstance.interceptors.request.use((config) => {
  const token = getToken();
  config.baseURL = getApiBaseUrl();
  if (config.headers) {
    if (!config.headers['Authorization']) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
  }

  return config;
});

STXAxiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  async (error: AxiosError) => {
    const originalConfig = error.config as InternalAxiosRequestConfig;

    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403) &&
      error.config &&
      error.config.url === REFRESH_ROUTE
    ) {
      localStorage.clear();
      window.location.reload();

      return;
    }

    if (error.response?.status === 401 && !originalConfig.isRetry) {
      originalConfig.isRetry = true;
      try {
        const storageKeys = getStorageKeysForNetwork();
        const refreshToken = localStorage.getItem(storageKeys.asignaRefresh);
        const refreshResponse = await STXAxiosInstance.post<RefreshResponse>('auth/refresh', {
          refreshToken,
        });
        if (refreshResponse.data.data) {
          setToken(refreshResponse.data.data.jwtToken);
          localStorage.setItem(
            storageKeys.asignaRefresh,
            refreshResponse.data.data.refreshToken.refreshToken
          );
          if (!originalConfig.headers) return;
          originalConfig.headers['Authorization'] = `Bearer ${refreshResponse.data.data.jwtToken}`;

          return STXAxiosInstance(originalConfig);
        }
      } catch (refreshError) {
        console.error(`${refreshError}`);

        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);
